import { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';

import { CustomMarker } from '../Map/CustomMarker';

interface MarkerProps {
    color: string;
}

const Marker = styled.div<MarkerProps>`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 16px;
    width: 16px;
    border-radius: 50%;
    background-color: ${(props) => props.color};
    border: 1px solid white;
    padding: 0;
`;

const MarkerCenter = styled.div`
    height: 4px;
    width: 4px;
    border-radius: 50%;
    background-color: white;
`;

interface MarkerIconProps {
    color: string;
    style?: CSSProperties;
}

export const MarkerIcon = ({ style, color }: MarkerIconProps) => {
    return (
        <Marker style={style} color={color}>
            <MarkerCenter />
        </Marker>
    );
};

MarkerIcon.displayName = 'MarkerIcon';

interface PositionMarkerProps {
    color: string;
    style?: CSSProperties;
    lat: number;
    lng: number;
    children?: ReactNode;
}

export const PositionMarker = ({ style, color, lat, lng, children }: PositionMarkerProps) => {
    return (
        <CustomMarker position={{ lat, lng }}>
            <Marker style={style} color={color}>
                <MarkerCenter />
            </Marker>
            {children}
        </CustomMarker>
    );
};

PositionMarker.displayName = 'PositionMarker';
